exports.linkResolver = (doc) => {
  switch (doc.type) {
    case "post":
      return `/blog/${doc.uid}`;
    
    case "accessori":
      const slug = doc.data?.slug?.text;
      return slug ? `/accessori/${slug}` : "/accessori";

    default:
      if (!doc.uid) return "/";
      return doc.uid;
  }
};
